import { z } from 'zod';
import { CONNECTION_LIST_LIMIT_MAX, CONNECTION_LIST_TOTAL_COUNT_MAX, ConnectionListQuerySchema, ConnectionSchema, } from './connection.js';
const TAGS = ['Connections'];
export const CONNECTIONS_BASE_ROUTE = '/connections';
/**
 * A bounded, not paged, result: the merge across four connection sources cannot be cheaply offset-
 * paginated, so the server returns at most `limit` connections and reports completeness instead of a
 * cursor.
 */
export const ConnectionListResponseSchema = z.object({
    connections: z
        .array(ConnectionSchema)
        .max(CONNECTION_LIST_LIMIT_MAX)
        .describe('The matching connections, ordered by last-updated descending, then by connection id.'),
    totalCount: z
        .number()
        .int()
        .min(0)
        .max(CONNECTION_LIST_TOTAL_COUNT_MAX)
        .describe('How many connections matched the query before the limit was applied, counted up to ' +
        `${CONNECTION_LIST_TOTAL_COUNT_MAX.toString()}; a value of ` +
        `${CONNECTION_LIST_TOTAL_COUNT_MAX.toString()} means at least that many matched.`),
    truncated: z
        .boolean()
        .describe('True when more connections matched than were returned; narrow the query to see the rest.'),
});
export const ConnectionListRoute = {
    method: 'get',
    fullPath: CONNECTIONS_BASE_ROUTE,
    summary: 'List integration connections',
    description: 'Lists the integration connections configured for an organization — SFTP feeds, API instances, ' +
        'interface engine (InterfaceEngine) connections, and newer SFTP connections from Resource ' +
        'Gateway — merged into one view. Each item carries the connection name, type, source, ' +
        'destination, method, data type, owning organization, and last-updated and last-activity ' +
        'timestamps. Use it to see what ' +
        'connections an organization has, of what type, and when each last changed or carried data; ' +
        'filter by type, data type, source, destination, method, or a free-text query. Results are scoped ' +
        'to the organizations the caller is authorized for and ordered by last-updated descending, then ' +
        'by connection id. This is a bounded result, not a paged one: at most `limit` connections are ' +
        'returned, `totalCount` reports how many matched (up to ' +
        `${CONNECTION_LIST_TOTAL_COUNT_MAX.toString()}), and \`truncated\` indicates some were omitted — ` +
        'a truncated result is not the full set, so narrow the query with filters rather than paging. ' +
        'InterfaceEngine connections are served from a cache and may be about an hour stale.',
    tags: TAGS,
    query: ConnectionListQuerySchema,
    response: ConnectionListResponseSchema,
};
//# sourceMappingURL=routes.js.map